/**
 * The org an access token speaks for: its `org_id` claim, or null when it names
 * none. The payload is decoded WITHOUT verifying the signature — this only tells
 * the client which org context its own token carries (the API reads the org
 * from this claim and verifies every token it receives), so it is never a trust
 * decision. Anything that does not decode to a JSON object carrying a non-empty
 * string claim reads as null; it never throws.
 */
export function tokenOrgId(token: string | null): string | null {
  const payload = token?.split(".")[1];
  if (!payload) return null;
  try {
    const binary = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const json = new TextDecoder().decode(Uint8Array.from(binary, (c) => c.charCodeAt(0)));
    const claims: unknown = JSON.parse(json);
    if (typeof claims !== "object" || claims === null || !("org_id" in claims)) return null;
    const orgId = claims.org_id;
    return typeof orgId === "string" && orgId !== "" ? orgId : null;
  } catch {
    return null;
  }
}
